import { useEffect, useRef, useState, type RefObject } from 'react';

/**
 * Szerokość elementu w pikselach (0 bez `ResizeObserver`, np. w testach).
 * Wspólne dla osi karty pojazdu (`VehicleGantt.tsx`) i harmonogramu floty
 * (`PlanTimeline.tsx`) — podpisy pasków dopasowane do szerokości (29.10.2026).
 */
export function useElementWidth<T extends HTMLElement>(): [RefObject<T | null>, number] {
  const ref = useRef<T>(null);
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver((entries) => {
      setWidth(entries[0]?.contentRect.width ?? 0);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return [ref, width];
}
